import * as React from "react";
import { FC } from "react";
import { ProductTypeOptions, ProductTypes } from "~/apps/pos/consts";
import { Product } from "~/apps/pos/models";
import Table from "~/common/components/Table";
import DropDownButtons from "~/common/controls/DropDownButtons";
import { currency } from "~/lib/formatters";

type Props = {
  data: Product[];
  canManage: boolean;
  isCategoryEnabled: boolean;
  onEdit: (row: Product) => void;
  onDelete: (row: Product) => void;
};

const ProductsTable: FC<Props> = ({ data, canManage, isCategoryEnabled, onEdit, onDelete }) => {
  const columns = [
    {
      Header: "Name",
      id: "name",
      accessor: (row: Product) => row.name,
    },
    {
      Header: "Type",
      id: "type",
      accessor: (row: Product) => ProductTypeOptions.labelsDict()[row.type],
    },
    {
      Header: "Price",
      id: "price",
      accessor: (row: Product) => (row.type !== ProductTypes.CUSTOM && `$${currency(row.price)}`) || "-",
    },
    {
      ...(isCategoryEnabled
        ? {
            Header: "Category",
            id: "category",
            accessor: (row: Product) => row.category?.name || "-",
          }
        : {}),
    },
    {
      Cell: (row) => {
        const options = [
          {
            onClick: () => onEdit(row.original),
            title: "Edit",
          },
          { onClick: () => onDelete(row.original), title: "Delete" },
        ];

        return canManage ? <DropDownButtons options={options} /> : null;
      },
      width: 100,
    },
  ];

  return (
    <Table
      data={data}
      columns={columns}
      onEdit={onEdit}
      onDelete={onDelete}
      showPagination={false}
      defaultPageSize={data.length}
    />
  );
};
export default ProductsTable;
